// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { Spacer } from "@aviary";
import { BackButton } from "@aviary/layouts";
import { useLocation } from "@shared/react-router-dom/react-router-dom";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import type { PatientAttributes } from "@unauthenticated/shared/data/types/PatientAttributes.d";
import { SignUpHeader } from "@unauthenticated/signupSignin/components/SignUpHeader/SignUpHeader";
import { SignUpTitle } from "@unauthenticated/signupSignin/components/SignUpTitle/SignUpTitle";
import { StoreLandingLayout } from "@unauthenticated/signupSignin/components/StoreLandingLayout/StoreLandingLayout";
import { StoreLogo } from "@unauthenticated/signupSignin/components/StoreLogo/StoreLogo";
import type { LocationType } from "@unauthenticated/signupSignin/data/types/PatientAuth";
import { l } from "@unauthenticated/signupSignin/locales/i18n";
import { PasswordForm } from "@unauthenticated/signupSignin/scenes/PatientAuthPasswordPage/PasswordForm/PasswordForm";

import * as styles from "./PatientAuthPasswordPage.styles";

interface Props {
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
  storeId?: string;
  activePatientPromotion?: boolean;
  isStorefronts?: boolean;
}

const PatientAuthPasswordPage = ({
  patientAttributes,
  additionalAttributes,
  storeId,
  activePatientPromotion,
  isStorefronts,
}: Props) => {
  const { t } = useTranslation();
  const formVersion = "StoreSignInPage";
  const {
    storeLogo,
    organizationLogo,
    storeName,
    treatmentPlanSlug,
    uuid,
    storeSlug,
    pracAvatar,
    iconLogo,
  } = patientAttributes;
  const FORGOT_PASSWORD_LINK = authRoutes.welcomeForgotPassword(
    storeSlug,
    uuid || treatmentPlanSlug
  );
  const { state }: LocationType = useLocation();

  const signUpTitle = isStorefronts ? t(l.signIn.signInAccount) : storeName;

  return (
    <StoreLandingLayout
      storeName={storeName}
      storeId={storeId}
      pracAvatar={pracAvatar}
      isActivePromotion={activePatientPromotion}
      isStorefronts={isStorefronts}
      organizationLogo={organizationLogo}
      iconLogo={iconLogo}
    >
      <SignUpHeader isStorefronts={isStorefronts}>
        {!!isStorefronts && (
          <div css={styles.backButtonWrapper}>
            <BackButton text={t(l.common.Back)} isUnderLined={false} />
          </div>
        )}
        {!isStorefronts && <StoreLogo storeLogo={storeLogo} storeName={storeName} />}
        <SignUpTitle title={signUpTitle} />
      </SignUpHeader>
      <Spacer height={isStorefronts ? "half" : "double"} />
      <PasswordForm
        isStorefronts={isStorefronts}
        additionalAttributes={{ ...additionalAttributes, formVersion }}
        email={state?.email}
        forgotPasswordLink={FORGOT_PASSWORD_LINK}
        storeId={storeId}
      />
    </StoreLandingLayout>
  );
};

export { PatientAuthPasswordPage };
